<template>
    <div class="unformal">
        <div class="tableCont">
            <el-drawer
                title="高级搜索"
                :visible.sync="drawerVisible"
                size="320px"
                class="drawerCont"
                ref="drawer"
                :wrapperClosable="false"
            >
                <el-scrollbar class="scrollbar">
                    <el-form
                        :model="searchForm"
                        label-width="120"
                        class="drawerForm"
                    >
                        <el-form-item label="员工姓名" size="small">
                            <el-input
                                clearable
                                placeholder="请输入员工姓名"
                                size="small"
                                v-model="searchForm.name"
                                @keydown.enter.native="userGet"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" size="small">
                            <el-input
                                clearable
                                placeholder="请输入联系电话"
                                size="small"
                                v-model.number="searchForm.phone"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                                @keydown.enter.native="userGet"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="所在部门" size="small">
                            <selectbutton
                                :props="props"
                                :options="optionData"
                                :value="menuId"
                                :clearable="isClearable"
                                :accordion="isAccordion"
                                @getValue="getValue($event)"
                                height="200"
                                ref="selectBtn"
                                placeholder="请选择所在部门"
                            ></selectbutton>
                        </el-form-item>
                        <el-form-item style="text-align: right">
                            <el-button
                                type="danger"
                                icon="el-icon-refresh-right"
                                size="small"
                                @click="clean"
                            >
                                重置条件
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
                <div class="drawer-footer">
                    <el-button
                        style="width: 100%"
                        type="primary"
                        icon="el-icon-search"
                        size="small"
                        @click="userGet(1)"
                    >
                        查询
                    </el-button>
                </div>
            </el-drawer>
            <div class="searchCont">
                <div class="searchContLeft">
                    <el-form
                        :inline="true"
                        :model="searchForm"
                        label-width="120"
                        @keydown.enter.native="userGet"
                    >
                        <el-form-item label="员工姓名" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入员工姓名"
                                size="mini"
                                v-model="searchForm.name"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入联系电话"
                                size="mini"
                                v-model.number="searchForm.phone"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                            >
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <el-button
                        icon="el-icon-search"
                        size="mini"
                        type="primary"
                        style="margin-right: 10px"
                        @click="userGet(1)"
                    ></el-button>
                    <div v-if="this.menuAuth">
                        <template v-for="item in menuAuth.slice(0, 2)">
                            <el-button
                                type="primary"
                                :key="item.id"
                                :icon="item.icon"
                                size="mini"
                                @click="authFunc(item.funcName)"
                            >
                                {{ item.name }}
                            </el-button>
                        </template>
                        <el-dropdown
                            v-if="menuAuth.length > 2"
                            @command="authFunc"
                            style="margin-left: 10px"
                        >
                            <el-button
                                type="primary"
                                size="mini"
                                icon="el-icon-arrow-down"
                            >
                                更多操作
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    :key="item.id"
                                    v-for="item in menuAuth.slice(2)"
                                    :command="item.funcName"
                                >
                                    <i :class="item.icon"> </i>
                                    {{ item.name }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div v-else></div>
                </div>
                <!-- 高级搜索 -->
                <advancedSearch :drawerVisible.sync="drawerVisible"
                    >高级搜索</advancedSearch
                >
            </div>
            <div class="table" :style="{ height: screen }">
                <el-table
                    :data="tableData"
                    ref="tableData"
                    highlight-current-row
                    height="100%"
                    @selection-change="handleSelectionChange"
                    @sort-change="sortChange"
                >
                    <el-table-column
                        type="selection"
                        align="left"
                        :fixed="checkFixed"
                    >
                    </el-table-column>
                    <el-table-column
                        label="工号"
                        property="job_no"
                        align="left"
                    >
                    </el-table-column>
                    <el-table-column
                        label="员工姓名"
                        property="name"
                        align="left"
                    >
                      <template slot-scope="scope">
                        <div class="nameCont">
                          <div class="headImg" >
                            <el-avatar v-if="scope.row.avatar!=''"
                                       size="small"
                                       :src="scope.row.avatar"
                            ></el-avatar>
                            <span v-else>
                    <el-avatar
                        size="small"
                        :src="'https://uc-api.loratech.cn/dingtalk/2/user/'+encodeURIComponent(scope.row.name)+'/avatar/50'"
                    ></el-avatar></span>

                          </div>
                          <div class="memberName">
                            {{ scope.row.name }}
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="联系电话"
                        property="phone"
                        width="120"
                        align="left"
                    ></el-table-column>
                    <el-table-column
                        label="性别"
                        property="sex_cn"
                        align="left"
                        width="60"
                    ></el-table-column>

                    <el-table-column
                        label="所属部门"
                        property="depart_name"
                        align="left"
                        width="200"
                    ></el-table-column>
                    <el-table-column
                        label="职位"
                        property="role_name"
                        align="left"
                        width="120"
                    ></el-table-column>
                    <el-table-column label="是否已婚" align="left">
                        <template slot-scope="scope">
                            {{ scope.row.marriage == 0 ? "未婚" : "已婚" }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="学历"
                        align="left"
                        prop="education"
                    >
                    </el-table-column>

                    <el-table-column
                        label="籍贯"
                        align="left"
                        prop="hometown"
                    >
                    </el-table-column>
                    <el-table-column
                        label="入职日期"
                        property="entry_date"
                        align="left"
                        :default-sort="{ prop: 'orderby_entry', order: null }"
                        sortable="custom"
                        width="120"
                    ></el-table-column>
                    <el-table-column
                        label="转正日期"
                        property="effect_date"
                        align="left"
                        width="120"
                        :default-sort="{ prop: 'orderby_effect_date', order: null }"
                        sortable="custom"
                    ></el-table-column>
                    <el-table-column
                        label="操作"
                        align="left"
                        width="200"
                        :fixed="operationFixed"
                    >
                        <template slot-scope="scope">
                            <div class="operation-btns">
                                <span
                                    v-for="item in scope.row.authority"
                                    :key="item.id"
                                >
                                <el-button
                                    type="text"
                                    size="small"
                                    :class="
                                        item.name == '删除' ? 'redText' : ''
                                    "
                                    @click="rowDo(scope.row, item)"
                                    >{{ item.name }}</el-button
                                >
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <pagination
                :paginationData="paginationData"
                @paginationChange="paginationChange"
            ></pagination>
        </div>

        <StaffRecordDetail
            :detailVisible.sync="detailVisible"
            :tableItem="tableItem"
        ></StaffRecordDetail>
        <StaffRecordEdit
            :editVisible.sync="editVisible"
            :tableItem="tableItem"
        ></StaffRecordEdit>
    </div>
</template>
<script>
import StaffRecordDetail from "./staffRecord/detail";
import StaffRecordAdd from "./staffRecord/add";
import StaffRecordEdit from "./staffRecord/edit";
import * as api from "@/http/api.js";
import * as oaApi from "@/http/oaApi.js";
import { tableMixin } from "@/utils/tableMixins.js";
import pagination from "@/comon/components/pagination";
import selectbutton from "@/comon/components/selectbutton";
import advancedSearch from "@/comon/components/advancedSearch";
export default {
    mixins: [tableMixin],

    data() {
        return {
            menuList: [],
            defaultActive: 0,
            searchForm: {
                name: "",
                phone: "",
                status: ""
            },
            menuId: 0,
            tableData: [],

            paginationData: {
                page: 1,
                "per-page": 20,
                total: ""
            },

            tableItem: [],
            detailVisible: false,
            addVisible: false,
            passwordVisible: false,
            editVisible: false,
            passwordForm: {
                password: "",
                passwordAgain: ""
            },
            rowId: "",
            bulkVisible: false,
            errArray: [],
            success_num: 0,
            failure_num: 0,

            statusList: [
                { status: "", name: "请选择" },
                { status: 1, name: "在职" },
                { status: 10, name: "离职" }
            ],

            selectionUserIdList: [],
            setRoleVisible: false,
            typeList: [],
            roleId: 4,
            searchFormH: "",
            orderby_entry: null,
            orderby_effect_date: null,
            importVisible: false,
            drawerVisible: false,

            isClearable: false, // 可清空（可选）
            isAccordion: true, // 可收起（可选）
            valueId: "", // 初始ID（可选）
            props: {
                // 配置项（必选）
                value: "id",
                label: "name",
                children: "child"
                // disabled: true
            },
            // 选项列表（必选）
            list: []
        };
    },
    methods: {
        // 取值
        getValue(value) {
            if (value) {
                this.menuId = value.id;
            } else {
                this.menuId = "";
            }
        },
        add() {
            this.addVisible = true;
        },
        onPreview(file) {
            window.open(file);
        },
        /**
         *  获取组织架构信息
         */
        depart() {
            api.depart({}, "get").then(res => {
                if (res) {
                    this.list = res.data;
                }
            });
        },
        /**
         * 菜单选择
         */
        handleSelect(val) {
            this.searchForm = {
                name: "",
                phone: ""
            };
            this.page = 1;
            this.perPage = 20;
            this.menuId = val;
            this.userGet();
        },
        /**
         * 获取离职员工列表
         */
        userGet(page) {
            page ? (this.paginationData.page = 1) : "";
            oaApi
                .probation(
                    {
                        depart_id: this.menuId,
                        orderby_entry: this.orderby_entry,
                        orderby_effect_date: this.orderby_effect_date,
                        menu_id: this.menu_id,
                        ...this.paginationData,
                        ...this.searchForm
                    },
                    "get"
                )
                .then(res => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.$refs.tableData.bodyWrapper.scrollTop = 0;
                        this.closeDrawer();
                    }
                });
        },
        /**
         * 根据table数据循环事件分发
         */
        rowDo(row, item) {
            if (item.id == 67) {
                this.tableItem = row;
                this.detailVisible = true;
            } else if (item.id == 66) {
                this.tableItem = row;
                this.editVisible = true;
            } else if (item.id == 62) {
                this.rowId = row.id;
                this.passwordVisible = true;
            }
        },
        // 回车事件
        enterKeyUp(e) {
            let key = window.event.keyCode || e.keyCode;
            if (key === 13) {
                this.userGet(1);
            }
        },
        bulkImport() {
            this.importVisible = true;
        },
        authFunc(funcName) {
            this[funcName]();
        },
        userExport() {
            oaApi
                .userExport(
                    {
                        selectList: this.selectionUserIdList,
                        depart_id: this.menuId,
                        ...this.searchForm,
                        probation: 1
                    },
                    "get"
                )
                .then(res => {
                    if (res) {
                        window.open(res.data.url);
                    }
                });
        },
        handleSelectionChange(val) {
            this.selectionUserIdList = [];
            for (let i in val) {
                this.selectionUserIdList.push(val[i].id);
            }
        },
        getRoleList() {
            oaApi.role({}, "get").then(res => {
                if (res) {
                    this.typeList = res.data;
                }
            });
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.userGet();
        },
        sortChange(column) {

          this.orderby_entry = null;
          this.orderby_effect_date = null;
          if (column.prop == "entry_date") {
            if (column.order == "descending") {
              this.orderby_entry = "desc";
            } else if (column.order == "ascending") {
              this.orderby_entry = "asc";
            }
          }
          if (column.prop == "effect_date") {
            if (column.order == "descending") {
              this.orderby_effect_date = "desc";
            } else if (column.order == "ascending") {
              this.orderby_effect_date = "asc";
            }
          }
            this.userGet();
        },
        clean() {
            this.searchForm = { name: "", phone: "", status: "" };
            if (this.$refs.selectBtn) {
                this.$refs.selectBtn.clearHandle();
            }
            this.menuId = "";
        },
        closeDrawer() {
            this.drawerVisible = false;
        }
    },
    created() {
        this.depart();
        this.userGet();
        document.addEventListener("keydown", this.enterKeyUp);
    },
    destroyed() {
        document.removeEventListener("keydown", this.enterKeyUp);
    },
    components: {
        StaffRecordDetail: StaffRecordDetail,
        pagination: pagination,
        StaffRecordEdit: StaffRecordEdit,
        selectbutton: selectbutton,
        advancedSearch: advancedSearch
    },
    computed: {
        menuAuth() {
            return this.$store.state.menu.menuAuth;
        },
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_id");
        },
        screen() {
            return `calc(100% - 40px - 40px)`;
        },
        /* 转树形数据 */
        optionData() {
            let cloneData = JSON.parse(JSON.stringify(this.list)); // 对源数据深度克隆
            return cloneData.filter(father => {
                // 循环所有项，并添加children属性
                let branchArr = cloneData.filter(
                    child => father.id == child.parent_id
                ); // 返回每一项的子级数组
                branchArr.length > 0 ? (father.child = branchArr) : ""; //给父级添加一个children属性，并赋值
                return father.parent_id == 0; //返回第一层
            });
        }
    }
};
</script>
<style lang="scss">
.unformal {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    .tableCont {
        // width: calc(100% - 250px);
        width: 100%;
        height: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        .table {
            height: calc(100% - 40px - 40px);
            width: 100%;
            .nameCont {
                display: flex;
                align-items: center;
                justify-content: start;
              .headImg {
                height: 28px;
                width: 28px;
                border-radius: 8px;
                overflow: hidden;
                margin-right: 8px;
                justify-items: flex-start;
                img{
                  width: 100%;
                }
              }
                .memberName {
                    line-height: 24px;
                }
            }
        }
    }
    .bulkImport {
        .bulkText {
            text-align: left;
        }
        .condition {
            width: 100%;
            li {
                text-align: left;
                line-height: 2;
            }
        }
    }
    // .el-scrollbar__wrap {
    //     overflow-x: hidden;
    // }
}
</style>
